import React from 'react'
import { setPageTitle } from 'hooks/setPageTitle'
import { TitleUtil } from 'utility/TitleUtil'
import { TemplateSideColumn } from 'shared/template/SideColumn'
import { Body } from './Body'

export const App = () => {
  setPageTitle(TitleUtil.about())

  return (
    <TemplateSideColumn content={<Body />} />
  )
}
